import _classCallCheck from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import { DefiActionBar } from "../actionBar";
import { DefiPagination } from "../pagination";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
var styles = {
  page: {
    width: "100%",
    height: "calc(100% - 64px)"
  },
  content: {
    margin: "0 5px",
    marginBottom: 64
  },
  title: {
    fontWeight: 300
  },
  loader: {
    height: "80%",
    textAlign: "center"
  },
  pagination: {
    width: "100%",
    position: "absolute",
    bottom: 76,
    height: 40,
    borderTop: "1px solid #ddd",
    paddingTop: 8
  }
};

var DefiPage =
/*#__PURE__*/
function (_Component) {
  _inherits(DefiPage, _Component);

  function DefiPage() {
    _classCallCheck(this, DefiPage);

    return _possibleConstructorReturn(this, _getPrototypeOf(DefiPage).apply(this, arguments));
  }

  _createClass(DefiPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.onMount) this.props.onMount();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          children = _this$props.children,
          error = _this$props.error,
          actions = _this$props.actions,
          loading = _this$props.loading,
          pageLoader = _this$props.pageLoader,
          pagination = _this$props.pagination,
          setMaxContentHeight = _this$props.setMaxContentHeight,
          hideActionBar = _this$props.hideActionBar;

      if (error) {
        return React.createElement("div", {
          className: classes.page,
          "data-testid": "DefiPage"
        }, React.createElement("div", {
          className: classes.content,
          style: setMaxContentHeight ? {
            height: "100%"
          } : undefined,
          "data-testid": "DefiPage-error"
        }, error), React.createElement(DefiActionBar, null, [{
          name: "Reload",
          onClick: function onClick() {
            if (_this.props.onMount) _this.props.onMount();
          },
          color: "primary"
        }]));
      }

      if (pageLoader ? pageLoader.loading : loading) {
        return React.createElement("div", {
          className: classes.page,
          "data-testid": "DefiPage"
        }, React.createElement("div", {
          className: classes.content,
          style: setMaxContentHeight ? {
            height: "100%"
          } : undefined
        }, React.createElement(Grid, {
          container: true,
          className: classes.loader,
          alignItems: "center"
        }, React.createElement(Grid, {
          item: true,
          xs: 12,
          "data-testid": "DefiPage-loading"
        }, React.createElement("h3", null, pageLoader ? pageLoader.message : loading), React.createElement("div", null, React.createElement(CircularProgress, {
          className: classes.progress,
          size: 50
        }))))));
      }

      return React.createElement("div", {
        className: classes.page,
        "data-testid": "DefiPage"
      }, React.createElement("div", {
        className: classes.content,
        style: setMaxContentHeight ? {
          height: "100%"
        } : undefined
      }, React.createElement("br", null), children), pagination && React.createElement("div", {
        className: classes.pagination
      }, pagination()), !hideActionBar && React.createElement(DefiActionBar, null, actions));
    }
  }]);

  return DefiPage;
}(Component);

export default withStyles(styles)(DefiPage);